import createI18NFunction from './create';

const translations = require(`./i18n.${process.env.BEM_LANG}.ts`);

export default createI18NFunction(translations);
